import { Panel } from "primereact/panel";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { oneDark } from "react-syntax-highlighter/dist/esm/styles/prism"

export default function HelpPage() {
    const highlightLines = new Set([10, 17, 19, 28]); // 1‑based line numbers

    return (<>
    <div style={{ overflowY: 'scroll' }}>
    <Panel header="Site map" toggleable={true} collapsed={false} className="shadow-2">
        <div className="p-text-normal">The web site consists of two parts visibility of each of them depends on the user role.
        </div><br />
        <div className="p-text-normal">The administrators will see a full navigation menu at the top, including Home, Activities, Manage, and Help sections. Ordinary learner users
            will only have access to the Home section, while all the other navigation options are hidden for them.</div>
    </Panel><br />

    <Panel header="Modules" toggleable={true} collapsed={true} className="shadow-2">
        <div className="p-text-normal">The learning process consists of lessons. This web site uses the term Module to represent single learning unit or lesson.
            Module is the smallest atomic logical block of the application that is providing space for building more complex logical blocks like courses (a series of lessons)
            which are gonna be explained later on below.
        </div><br />
        <div className="p-text-normal">There are two kinds of modules supported by the system.</div>
        <ul>
            <li>Standalone unmanaged modules</li>
            <li>Managed modules</li>
        </ul><br />
        <div className="p-text-normal">A standalone unmanaged module is in essense one HTML file that contains all the lesson logic, HTML transitions,
            navigation within the lesson content, and any other activity used by the HTML author. THe HTML page is usually authored externally using any tool of
            the author prefrence and then the complete HTML source is simply copied and pasted into this web site as a whole.</div><br />
        <div className="p-text-normal">A managed module consists of multiple HTML fragments that contain the lesson logic. Each fragment contains single HTML page
            without any transitions. The navigation between pages is managed externally by the application by means of transition buttons located at the bottom of the
            module viewer. These actions are not limited to just navigating between the fragments; they include validating user input, comparing user answers to correct
            answers and calculating the score, showing correct answers, resettting the input values to their initial state so the user can start their answering session anew.
            The author creates the HTML page within the application using rich text editor that enables simple formatting to be applied, standard features like lists and 
            various font styles as well as advanced controls like collapsible panels, tables, callouts, and other presets. Also, it is possible to embed audio files into the
            editor, as well as images and Youtube video clips. Of course, the editor provides the lesson author to embed various kinds of input fieds into the HTML page, ranging 
            from simple text and drop down elements to more complex elements like quizes where the user can select proper answers from corresponiding select choices within a
            question matrix.
        </div><br />
        <div className="p-text-normal">Since the managed module navigation and user interaction with the imput forms in a managed module is fully controlled by the appllication,
            it provides out of the box way of keeping the user interaction within the application and monitoring user activities related to the learnig process by the administrator.</div><br/>
        <div className="p-text-normal">Last but not least, a managed module uses the theme currently selected by the user. Therefore, each user will see the module material
            in their favorite color theme depending on the user preferences or visual limitations. This ensures a smooth user experience while using the web site itself or
            accessing the module content.</div>
    </Panel><br />

    <Panel header="Courses" toggleable={true} collapsed={true} className="shadow-2">
        <div className="p-text-normal">Course consists of a serie of lessons arranged in certain order. A course may contain an unlimited number of modules that have to 
            be completed by the learner one after the other. The user would not be presented with an option to start a particular course module if there are preceding modules
            that were not completed yet.
        </div><br />
        <div className="p-text-normal">If a module can be thought of as a single lesson, the course represents a semester in university terminology.
        </div><br />
    </Panel><br />

    <Panel header="The process" toggleable={true} collapsed={true} className="shadow-2">
        <div className="p-text-normal">The application provides several ways to specify the order a learner can consume the learning material. This is done by enabling
            dependencies amont different building blocs of the application such as modules and courses.
        </div><br />
        <div className="p-text-normal">The availability of a particular module to be consumed by a learner is established by the administrator specifying prerequisites for 
            a learning unit. These prerequisites can be defined at different levels:
            <ul>
                <li>Course to Course dependency defines prerequisite course(s) for a given course.</li>
                <li>Module to Module within single course dependency defines the order modules within a course can be consumed. For example, "Pronouns" module would have "Nouns" as a
                    prerequisite because it is kinda impossible to explain the concept of a pronoun if the lerner has no idea what noun is. Therefore, the course "Parts of Speech" would
                    most probably have "Nouns" as a prerequisite module for "Pronouns".
                </li>
                <li>A standalone Module to Module dependency defines prerequisite modules for a module regardless of them being a part of a course or not. Course is an optional buiding block
                    of the application which may or may not be used by the administrators, so this kind of a dependency will serve its role if no courses are used.
                </li>
            </ul>
        </div><br />
        <div className="p-text-normal">The user learning path is calculated by the application automatically based on the dependencies above; the user is presented with the full 
            list of modules available for them grouped in distinct groups based on the module availability.
            <ul>
                <li>Available - the modules the user has not started exploring yet, but can start that process any time because the modules in this section do not have any incomplete
                    dependencies.</li>
                <li>In Progress - same as above, but the user has already opened the modules in this section at least once which triggers the module status from New to In Progress.</li>
                <li>Locked - the modules that have prerequisites not yet completed by the user.</li>
                <li>Completed - the modules the user has marked as completed.</li>
            </ul>
        </div><br />
    </Panel><br />

    <Panel header="Users" toggleable={true} collapsed={true} className="shadow-2">
        <div className="p-text-normal">User is the main consumer of the learning materials or a site administrator who can author the modules, courses,
            and manage users and user assignments.
        </div><br />
        <div className="p-text-normal">The learning blocks can be assigned to a particular user at different levels.
            <ul>
                <li>Module level - an individual module is assigned to the user and becomes available if the prerequisite conditions are met.</li>
                <li>Course level - a course is assigned to the user as a whole and all units included into the course become available to the user.</li>
            </ul>
        </div><br />
        <div className="p-text-normal">New users are created by the users themselves via a sign-up process. Once the user signs up they can access the web site
            even though they will see an empty home page until the administrator assignes one or more modules to them.
        </div><br />
        <div className="p-text-normal">The administrator can edit users information or lock out users disabling their access to the web site.
        </div>
    </Panel><br />

    <Panel header="Tracking user activities via custom events" toggleable={true} collapsed={false} className="shadow-2">
        <div className="p-text-normal">This section is applicable to unmanaged units only because the session tracking is implemented in managed
            modules out of the box so there is no need for any additional action in order to have this information stored in the database.</div>
        <div className="p-text-normal">The HTML file that contains the module content is displayed in an <code>iframe</code> element.</div>
        <div className="p-text-normal">The <code>iframe</code> can use <code>JavaScript</code> to send messages to it's parent window.</div>
        <div className="p-text-normal">The parent window aware of the custom events that can be sent by the HTML document and records 
            them in the database so that they can be viewed and analysed later.</div>
        <div className="p-text-normal">&nbsp;</div>
        <h4 className="explorer-title">A <code>JavaScript</code> fragment that posts a custom text:</h4>
        <SyntaxHighlighter language="javascript" style={oneDark}>
            {`window.parent.postMessage({ type: 'custom-event', payload: 'Hello from iframe!' }, '*');`}
        </SyntaxHighlighter>
        <h4 className="explorer-title">A <code>JavaScript</code> fragment that posts a <code>JavaScript</code> object:</h4>
        <SyntaxHighlighter language="javascript" style={oneDark}>
            {`const o = { prop1: 'value1', prop2: 12123 };
window.parent.postMessage({ type: 'custom-event', payload: o }, '*');`}
        </SyntaxHighlighter>
        <div className="p-text-normal">The class can be constructed dynamically by the <code>JavaScript</code> code to provide actual information
        entered by the user, user answers along with the correct answers, and so on depending on what information is important to be stored.</div>
    </Panel><br />

    <Panel header="Sessions and events" toggleable={true} collapsed={true} className="shadow-2">
        <div className="p-text-normal">Every time the user clicks View and opens a module a new session is started. Session stands for the whole interaction
            of the user with the selected module until the user closes the module dialog. This is where the session ends. Session has start and end time
            which allows to see how much time the user spent on interacting with the module.
        </div>
        <div className="p-text-normal">Each custom event posted by the module document is recorded as a par of the session. This means that if the user 
            opens a module for the first time, a new session is created and the custom events are recorded for this particular session. If the user opens
            the same document for the second time, another session is started and he events are recorded in a context of this session.
        </div>
        <div className="p-text-normal">The scenario above is logically organised like this:</div>
        <pre className="p-p-3" style={{ background: "#272822", color: "#f8f8f2", borderRadius: "6px" }}>
            <code>{`Session 1
    Event 1
    Event 2
    ...
    Event N
    
Session 2
    Event 1
    Event 2
    ...
    Event M
    `}</code></pre>
    </Panel><br />

    <Panel header="Testing the events" toggleable={true} collapsed={true} className="shadow-2">
        <div className="p-text-normal">The events sent by the document to the application can be tested on the Manage / Modules page.</div>
        <div className="p-text-normal">
            <ol>
                <li>Navigate to the Manage / Modules page</li>
                <li>Select a module in the left pane</li>
                <li>Click the Test button above the document preview</li>
                <li>The events posted by the document will be shown below the document</li>
            </ol>
        </div>        
    </Panel><br />

    <Panel header="Real life usage example" toggleable={true} collapsed={true} className="shadow-2">
        <div className="p-text-normal">The HTML module had a function to display both user and correct answers to the user for a review.
            This was a good place to record user's answers along with the correct ones and store this information in a database for the administrator to
            review it and provide feedback to the user if necessary. The original function that calculated user score was like this:
        </div>
        <SyntaxHighlighter language="javascript" style={oneDark} showLineNumbers>
            {`function revealAnswers() {
const answers = [
    { row: 1, correct: 'verb' },
    { row: 2, correct: 'noun' },
    { row: 3, correct: 'adjective' },
    { row: 4, correct: 'adverb' }
];

answers.forEach(answer => {
    const input = document.getElementById(\`answer-\${answer.row}\`);
    const feedback = document.getElementById(\`feedback-\${answer.row}\`);

    input.value = answer.correct;
    input.style.borderColor = '#f97316';
    input.disabled = true;

});
}`}
        </SyntaxHighlighter>
        <div className="p-text-normal">The function did not create any object that could be submitted as-is, e.g. en object that contained both user
            and correct answers. Therefore, such an object creation routine was added to the original function body so the modified function looked
            like this (added lines are highlighted and supplied by a comment).
        </div>
        <SyntaxHighlighter language="javascript" style={oneDark} wrapLines showLineNumbers
            lineProps={(lineNumber: number) => {
                if (highlightLines.has(lineNumber)) {
                    return {
                        style: { backgroundColor: "rgba(255, 255, 0, 0.2)" }
                    };
                }
                return {};
            }}>
            {`function revealAnswers() {
const answers = [
    { row: 1, correct: 'verb' },
    { row: 2, correct: 'noun' },
    { row: 3, correct: 'adjective' },
    { row: 4, correct: 'adverb' }
];

// create an object to be passed to the parent window and recorded in the database
const payload = { event: 'revealAnswers', answers: [] }

answers.forEach(answer => {
    const input = document.getElementById(\`answer-\${answer.row}\`);
    const feedback = document.getElementById(\`feedback-\${answer.row}\`);

    // get the user answer from the corresponding intpu
    const userAnswer = input.value.trim().toLowerCase();
    // add the answer information to the array of payload.answers
    payload.answers.push({ row: answer.row, userAnswer, correctAnswer: answer.correct });

    input.value = answer.correct;
    input.style.borderColor = '#f97316';
    input.disabled = true;

});

// post the payload object to the parent window to be recorded as a user session event
window.parent.postMessage({ type: 'custom-event', payload }, '*');
}`}
        </SyntaxHighlighter>
    </Panel>
    </div>
    </>);
}
